export default __webpack_public_path__ + "static/media/empty-nofound.6687ec11.svg";